import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.catalogs-slider';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const slider = document.createElement('div');
      slider.classList.add('splide');
      const track = document.createElement('div');
      track.classList.add('splide__track');
      const list = document.createElement('div');
      list.classList.add('splide__list');

      slider.appendChild(track);
      track.appendChild(list);

      data.forEach((item) => {
        const slide = document.createElement('div');
        slide.classList.add('splide__slide');
        slide.innerHTML = /* html */ `
          <a href="${item.link}" class="catalog-card">
            <img src="${item.background}" alt="${item.title}">
            <h3>${item.title}</h3>
            <button class="btn-custom secondary">View catalog</button>
          </a>
        `;

        list.appendChild(slide);
      });

      const splide = new Splide(slider, {
        type: 'loop',
        perPage: 4,
        perMove: 4,
        arrows: true,
        pagination: false,
        gap: 30,
        breakpoints: {
          1200: {
            perPage: 3,
            perMove: 3,
          },
          991: {
            perPage: 2,
            perMove: 2,
          },
          600: {
            perPage: 1,
            perMove: 1,
          },
        },
      });

      splide.mount();

      query.appendChild(slider);
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
